import { render } from "./legoDropHolderItemIconExtend.vue?vue&type=template&id=60f35779&scoped=true"
import script from "./legoDropHolderItemIconExtend.vue?vue&type=script&lang=js"
export * from "./legoDropHolderItemIconExtend.vue?vue&type=script&lang=js"

import "./legoDropHolderItemIconExtend.vue?vue&type=style&index=0&id=60f35779&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f35779"],['__file',"src/components/lego/extend/legoDropHolderItemIconExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60f35779"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60f35779', __exports__)) {
    api.reload('60f35779', __exports__)
  }
  
  module.hot.accept("./legoDropHolderItemIconExtend.vue?vue&type=template&id=60f35779&scoped=true", () => {
    api.rerender('60f35779', render)
  })

}


export default __exports__